import ReplayPixiStage from "@Components/game/session-results/feedback/visualization/replay-pixi-stage";
import { SessionFeedbackModel } from "@hooks/game/activity/session/use-session-feedback-model";
import { Stack } from "@mui/material";
import { useMemo } from "react";

interface IReplay2DVisualization {
  feedbackModel: SessionFeedbackModel;
  onReadyChange?: (isReady: boolean) => void;
}

const ReplayVisualization2D = ({ feedbackModel, onReadyChange }: IReplay2DVisualization) => {
  const { playback } = feedbackModel;
  const replayStageOptions = useMemo(
    () => ({
      resolution: Math.min(window.devicePixelRatio || 1, 1.5),
      autoDensity: true,
      antialias: false,
      powerPreference: "high-performance" as const,
      backgroundAlpha: 0,
      backgroundColor: 0x000000,
    }),
    []
  );

  return (
    <Stack
      ref={playback.containerRef}
      width="100%"
      flex="0 0 87.5%"
      position="relative"
      sx={{
        backgroundColor: "transparent",
        overflow: "hidden",
      }}
      justifyContent="center"
      alignItems="center"
    >
      <ReplayPixiStage
        feedbackModel={feedbackModel}
        stageOptions={replayStageOptions}
        onReadyChange={onReadyChange}
      />
    </Stack>
  );
};

export default ReplayVisualization2D;
